import React, { useState, useEffect, useMemo, useRef } from "react";
import Button from "../../components/button/button";
import Table from "../../components/table/table";
import Input from "../../components/inputs/input/input";
import Modal from "../../components/modal/modal";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import { columns } from "./data/data";
import { getApiInstance } from "../../utils/api";
import { FiEdit, FiTrash } from "react-icons/fi";
import Popup from "../../components/popup/popup";

import "./maestroDotaciones.scss";
import InputSearch from "../../components/inputs/inputSearch/inputSearch";
import Notification from "../../components/notification/notification";
import InputDropdown from "../../components/inputs/inputDropdown/inputDropdown";


export default function MaestroDotaciones() {
    const [dotaciones, setDotaciones] = useState([]);
    const api = getApiInstance();
    const [categoriaOptions, setCategoriaOptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [newDotacion, setNewDotacion] = useState({
        referencia: "",
        dotacion: "",
        descripcion: "",
        thumbnail: "",
        rutaPlano: null,
        rutaPlanoUrl: "",   
        pdfFileName: "",
        unidades: "",
        codDotacion: null,
        codCategoria: [],
    });

    // Estados para los mensajes de error de cada campo
    const [referenciaError, setReferenciaError] = useState("");
    const [dotacionError, setDotacionError] = useState("");
    const [imagenError, setImagenError] = useState("");
    const [pdfError, setPdfError] = useState("");
    const [categoriaError, setCategoriaError] = useState("");


    const notificationRef = useRef(null);

    // Estado para manejar la eliminación de dotaciones con el popup
    const [dotacionAEliminar, setDotacionAEliminar] = useState(null); //guardaremos la dotación que se va a eliminar
    const [isPopupOpen, setIsPopupOpen] = useState(false);




    useEffect(() => {
        fetchDotaciones();
    }, []);

    useEffect(() => {
        fetchCategorias();
    }, []);

    const fetchDotaciones = async () => {
        try {
            const response = await api.get("/api/Dotacion/GetAllDotaciones");
            setDotaciones(response.data);
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al obtener las dotaciones.",
                "error"
            );
        }
    };

    const fetchCategorias = async () => {
        try {
            const response = await api.get("/api/Categoria/GetSubfamilias");
            const formattedOptions = response.data.map((categoria) => ({
                label: categoria.nombreSubfamilia, // Asignar nombreSubfamilia como label
                value: categoria.codCategoria, // Asignar codCategoria como value
            }));
            setCategoriaOptions(formattedOptions);
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al obtener las categorías.",
                "error"
            );
        }
    };
    
    
    const handlePdfChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileUrl = URL.createObjectURL(file);
            setNewDotacion((prev) => ({
                ...prev,
                rutaPlano: file,
                rutaPlanoUrl: fileUrl,
            }));
        }
    };

    const handleChange = (e) => {
        setNewDotacion({
            ...newDotacion,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const api = getApiInstance();

        // RESET de los mensajes de error
        setReferenciaError("");
        setDotacionError("");
        setImagenError("");
        setPdfError("");

        // Validaciones para los campos obligatorios
        let hasError = false;

        if (!newDotacion.referencia) {
            setReferenciaError("El campo referencia es obligatorio.");
            hasError = true;
        }

        if (!newDotacion.dotacion) {
            setDotacionError("El campo nombre de la dotación es obligatorio.");
            hasError = true;
        }

        // if (!newDotacion.image && !isEditing) {
        //     setImagenError("El campo imagen es obligatorio.");
        //     hasError = true;
        // }     

        // if (!newDotacion.rutaPlano && !isEditing) {
        //     setPdfError("El campo plano es obligatorio.");
        //     hasError = true;
        // }

        if (!newDotacion.codCategoria || newDotacion.codCategoria.length === 0) {
            setCategoriaError("Debe seleccionar al menos una imagen.");
            hasError = true;
        }

        if (hasError) return; // Si hay errores, detener el proceso
            
        // Convierte el array de categorías en una cadena separada por comas
        const categoriasString = newDotacion.codCategoria.join(",");

        try {
            const formData = new FormData();
            formData.append("referencia", newDotacion.referencia);
            formData.append("dotacion", newDotacion.dotacion);
            formData.append("unidades", newDotacion.unidades); 
            formData.append("descripcion", newDotacion.descripcion);
            formData.append("codCategoria", categoriasString);

            if (newDotacion.image) {
                formData.append("image", newDotacion.image);
            }

            if (newDotacion.thumbnail) {
                formData.append("thumbnail", newDotacion.thumbnail);
            }

            if (newDotacion.rutaPlano) {
                // Si se subió un nuevo archivo para el plano
                formData.append("plano", newDotacion.rutaPlano);
            } else if (newDotacion.rutaPlanoUrl) {
                // Si no se subió un nuevo archivo, envía la URL existente del plano
                formData.append("rutaPlano", newDotacion.rutaPlanoUrl);
            }
            // } else {
            //     // Si no hay ni archivo nuevo ni URL existente, marca error
            //     setPdfError("El campo plano es obligatorio.");
            //     hasError = true;
            // }
            
            formData.append("codDotacion", newDotacion.codDotacion);

            if (isEditing) {
                await api.put(
                    `/api/Dotacion/${newDotacion.codDotacion}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                notificationRef.current.addNotification(
                    "Dotación actualizada correctamente.",
                    "success"
                );
            } else {
                await api.post("/api/Dotacion", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                notificationRef.current.addNotification(
                    "Dotación añadida correctamente.",
                    "success"
                );
            }

            setIsModalOpen(false);
            setIsEditing(false);
            fetchDotaciones();
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al guardar la dotación. Por favor, inténtelo de nuevo.",
                "error"
            );
        }
    };

    const handleEdit = (dotacion) => {
        setNewDotacion({
            referencia: dotacion.referencia || "",
            dotacion: dotacion.nombreDotacion || "",
            descripcion: dotacion.descripcion || "",
            thumbnail: dotacion.thumbnail || "",
            rutaPlano: null,
            rutaPlanoUrl: dotacion.rutaPlano || "",
            pdfFileName: dotacion.rutaPlano ? dotacion.rutaPlano.split("/").pop() : "",
            unidades: dotacion.unidades || "",
            codDotacion: dotacion.codDotacion || null,
            codCategoria: dotacion.codCategoria || [],
        });
        // Limpiar los errores al editar
        setReferenciaError("");
        setDotacionError("");
        setImagenError("");
        setIsEditing(true);
        setIsModalOpen(true);
    };

    const handleAdd = () => {
        setNewDotacion({
            referencia: "",
            dotacion: "",
            thumbnail: "",
            codDotacion: null,
            pdfFileName: "",
            codCategoria: [],
        });
        // Limpiar los errores al añadir
        setReferenciaError("");
        setDotacionError("");
        setImagenError("");
        setCategoriaError("");
        setIsEditing(false);
        setIsModalOpen(true);
    };

    // Mostrar el Popup antes de eliminar
    const confirmDeleteDotacion = (dotacion) => {
        setDotacionAEliminar(dotacion);
        setIsPopupOpen(true);
    };

    const handleConfirmDelete = async () => {
        const api = getApiInstance();

        try {
            await api.delete(`/api/Dotacion/${dotacionAEliminar.codDotacion}`);
            notificationRef.current.addNotification(
                "Dotación eliminada correctamente.",
                "success"
            );
            fetchDotaciones();
            setIsPopupOpen(false);
        } catch (error) {
            notificationRef.current.addNotification(
                "Error al eliminar la dotación.",
                "error"
            );
            setIsPopupOpen(false);
        }
    };

    const actions = (row) => [
        {
            label: "Editar",
            onClick: () => handleEdit(row),
            icon: <FiEdit />,
        },
        {
            label: "Eliminar",
            onClick: () => confirmDeleteDotacion(row),
            icon: <FiTrash />,
        },
    ];

    const filteredDotaciones = useMemo(() => {
        return dotaciones.filter((dotacion) =>
            Object.values(dotacion).some((value) =>
                value !== null &&
                value !== undefined &&
                value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, dotaciones]);
    
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileUrl = URL.createObjectURL(file);
            setNewDotacion({
                ...newDotacion,
                image: file,
                thumbnail: fileUrl,
            });
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setReferenciaError("");
        setDotacionError("");
        setImagenError("");
    };
    console.log("categoriaOptions:", categoriaOptions);
    console.log("newDotacion.codCategoria:", newDotacion.codCategoria);

    return (
        <section className="maestro-dotaciones">
            <Notification ref={notificationRef} />
            <SectionHeader title="Maestro de Dotaciones" />

            <div className="maestro-dotaciones__content">
                <div className="maestro-dotaciones__content__table-header">
                    <InputSearch
                        context="tableSearch"
                        placeholder="Buscar..."
                        onSearch={setSearchTerm}
                    />

                    <div className="maestro-dotaciones__content__table-header__buttons">
                        <Button
                            label="Añadir dotación"
                            variant="filled"
                            onClick={handleAdd}
                        />
                    </div>
                </div>

                <Table
                    columns={columns(handleEdit, confirmDeleteDotacion)}
                    data={filteredDotaciones}
                    actions={actions}
                    pagination={{
                        rowsPerPage: 10,
                    }}
                    noResultsMessage="No se ha encontrado ningún resultado."
                />
            </div>

            <Modal
                title={isEditing ? "Editar Dotación" : "Añadir Dotación"}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onAccept={handleSubmit}
            >
                <div className="maestro-dotaciones__modal">
                    <form className="maestro-dotaciones__modal__content">
                        <Input
                            type="text"
                            label="Referencia"
                            name="referencia"
                            placeholder="Introduce la referencia"
                            value={newDotacion.referencia}
                            onChange={handleChange}
                        />
                        {referenciaError && (
                            <p className="error">{referenciaError}</p>
                        )}

                        <Input
                            type="text"
                            label="Dotación"
                            name="dotacion"
                            placeholder="Introduce el nombre de la dotación"
                            value={newDotacion.dotacion}
                            onChange={handleChange}
                        />
                        {dotacionError && (
                            <p className="error">{dotacionError}</p>
                        )}
                        <InputDropdown
                            label="Categoría"
                            withCheckboxes={true}
                            options={categoriaOptions}
                            onSelect={(selectedOptions) => {
                                setNewDotacion((prev) => ({
                                    ...prev,
                                    codCategoria: selectedOptions || [],
                                }));
                            }}
                            value={newDotacion.codCategoria} // Pasar el array de categorías seleccionadas
                            placeholder="Selecciona una o más categorías"
                        />
                        {categoriaError && <p className="error">{categoriaError}</p>}
                        <Input
                            type="file"
                            label="Miniatura"
                            name="image"
                            onChange={handleImageChange}
                        />
                        {newDotacion.thumbnail && (
                            <div className="image-preview">
                                <img
                                    src={newDotacion.thumbnail}
                                    alt="Thumbnail actual"
                                />
                            </div>
                        )}
                        {imagenError && <p className="error">{imagenError}</p>}
                        <Input
                            type="file"
                            label="Plano"
                            name="rutaPlano"
                            onChange={handlePdfChange}
                        />
                        {pdfError && <p className="error">{pdfError}</p>}
                        {newDotacion.pdfFileName && (
                            <p className="pdf-name">
                                Archivo del plano actual: {newDotacion.pdfFileName}
                            </p>
                        )}
                        {/*TODO: Implementar previsualizacion si hiciera falta*/}
                        {/* {newDotacion.rutaPlanoUrl  && (
                            <div className="pdf-preview">
                                <iframe
                                    src={newDotacion.rutaPlanoUrl}
                                    title="Vista previa del plano"
                                    width="100%"
                                    height="400px"
                                    style={{ border: "none" }}
                                ></iframe>
                            </div>
                        )} */}
                        <Input
                            type="number"
                            label="Unidades fijas tienda"
                            name="unidades"
                            placeholder="Introduce las unidades"
                            value={newDotacion.unidades}
                            onChange={handleChange}
                        />
                        <Input
                            type="text"
                            label="Descripción"
                            name="descripcion"
                            placeholder="Introduce la descripción"
                            value={newDotacion.descripcion}
                            onChange={handleChange}
                        />
                    </form>
                </div>
            </Modal>
            {isPopupOpen && (
                <Popup
                    type="alert"
                    alertType="warning"
                    titleMessage="Confirmar eliminación"
                    alertMessage={`¿Estás seguro de que deseas eliminar la dotación"?`}
                    onConfirm={handleConfirmDelete}
                    onClose={() => setIsPopupOpen(false)}
                    confirmLabel="Eliminar"
                    cancelLabel="Cancelar"
                />
            )}
        </section>
    );
}
